import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';

import CloseIconUrl from '../../../../resources/icons/icon-close.svg';

function GifPreviewDialog({ classes, open, src, alt, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      classes={{ paper: classes.gifDialogPaper }}
    >
      <IconButton
        onClick={onClose}
        aria-label="Fermer l'aperçu"
        className={classes.gifDialogCloseButton}
      >
        <img src={CloseIconUrl} alt="" className={classes.gifDialogCloseIcon} />
      </IconButton>
      <DialogContent className={classes.gifDialogContent}>
        <img
          key={src}
          src={src}
          alt={alt}
          className={classes.gifDialogImage}
        />
      </DialogContent>
    </Dialog>
  );
}

GifPreviewDialog.propTypes = {
  alt: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  src: PropTypes.string.isRequired,
};

GifPreviewDialog.defaultProps = {
  alt: 'Animation',
};

export default GifPreviewDialog;
